import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
const Disabilities = ({ disabilities }) => {
    const { Disabilities: css } = useTheme('PassengersDetails');
    const { t } = useTranslation('OrderCard');
    return (React.createElement("div", { className: css.root },
        React.createElement("div", { className: css.disabilities },
            React.createElement("div", { className: css.disabilities__header }, t('Additional information')),
            React.createElement("div", { className: css.disabilities__list }, disabilities.map(disability => (React.createElement(React.Fragment, { key: disability.id },
                React.createElement("span", null, disability.id),
                React.createElement("span", null, '-'),
                React.createElement("span", null, disability.name))))))));
};
export default Disabilities;
